
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue"
import DutyPermissionsContent from "./components/DutyPermissionsContent.vue";

export default defineComponent({
  name: "DutyPermissionsPage",
  components: {
    BreadCrumb,
    DutyPermissionsContent,
  },
});
